<template>
    <div class="w100">
        <article class="wContent center">
            <el-row :gutter="20">
                <el-col :span="16">
                    <div class="grid-content infor-list" style="padding-top: 10px;">
                        <div class="mw-fast-list-box">
                            <span class="mw-fast-list-sub" @click="changeInforTab(item, '快讯')">快讯</span>
                            <span class="mw-fast-list-sub" :class="{fontBold: name == item.type_name, fontRed: name == item.type_name}" v-for="(item, index) in inforTab_list" :key="index" @click="changeInforTab(item)">{{ item.type_name }}</span>
                        </div>

                        <div class="mw-modular-box p20 bgWhite" style="min-height: 1440px;"
                            v-loading="loading"
                            element-loading-text="拼命加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(255, 255, 255, 1)"
                        >
                            <p style="margin-bottom: 20px; border-bottom: 1px solid #ccc; padding-bottom: 15px;" class="font14"><span class="fontBold font16">{{ '“' + name + '”' }}</span> 相关资讯</p>
                            <div v-show="consult_list.length == 0" class="font14 textCenter">未查到资讯信息</div>
                            <div v-for="(item, index) in consult_list" :key="index">
                                <div class="part-tab-clist pointer" v-show="item.pic" @click="goDetailPage(item.primary_id)">
                                    <span class="tag textCenter" :title="item.type_name">{{ item.type_name }}</span>
                                    <div style="flex: 1; max-width: 147px;"> <img :src="'data:image/jpeg;base64,' + item.pic" alt="" srcset=""> </div>
                                    <div style="flex: 4;" class="w100 textLeft main">
                                        <h4 class="font16 fontBold fontNormal">{{ item.the_title }}</h4>
                                        <div class="main-sub fontLight">{{ item.overview }}</div>
                                        <div class="main-tags-box">
                                            <span v-if="item.the_table">
                                                <span v-for="(table, tableI) in item.the_table.split(',')" :key="tableI" style="margin-right: 5px;" class="inlineBlock">
                                                    <span class="main-tag fontRed" v-if="table" @click.stop="goSearchPage(table)">{{ table }}</span>
                                                </span>
                                            </span>
                                            <span v-if="item.the_table">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                            <span>{{ item.oper_man ? item.oper_man : '未知' }}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                            <span>{{ compareTime(item.create_date) }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="part-tab-clist pointer" v-show="!item.pic" @click="goDetailPage(item.primary_id)" style="border-bottom: 1px solid #eee;">
                                    <span class="tag textCenter" :title="item.type_name">{{ item.type_name }}</span>
                                    <div class="w100 textLeft main" style="padding-left: 10px">
                                        <h4 class="font16 fontBold fontNormal" style="margin-left: 70px">{{ item.the_title }}</h4>
                                        <div class="main-sub fontLight">{{ item.overview }}</div>
                                        <div class="main-tags-box">
                                            <span v-if="item.the_table">
                                                <span v-for="(table, tableI) in item.the_table.split(',')" :key="tableI" style="margin-right: 5px;" class="inlineBlock">
                                                    <span class="main-tag fontRed" v-if="table" @click.stop="goSearchPage(table)">{{ table }}</span>
                                                </span>
                                            </span>
                                            <span v-if="item.the_table">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                            <span>{{ item.oper_man ? item.oper_man : '未知' }}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                            <span>{{ compareTime(item.create_date) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="textRight bgWhite" style="padding-top: 10px;" v-show="consult_list.length > 0">
                                <el-pagination background @current-change="handleCurrentChange" :current-page="pagenum" :page-size="10" layout="total, prev, pager, next, jumper" :total="totalnum"></el-pagination>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <div class="varieties-box bgWhite" style="margin-top: 10px;">
                            <h4>
                                <span class="font14 block">品种报告</span>
                                <span class="block textRight"><a class="fontDark pointer font14" @click="goReportPage('')">更多+</a></span>
                            </h4>
                            <div class="varieties-list">
                                <span v-for="(item, index) in reportClassify" :key="index" @click="goReportPage(item.sortId)"><a class="fontWhite pointer">{{ item.sortName }}</a></span>
                            </div>
                        </div>

                        <MapControl></MapControl>

                        <PriceIndexControl class="mw-modular-box"></PriceIndexControl>

                        <HotRecord class="mw-modular-box" :ad="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adPicturePath'] : '') : ''" :link="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adLink'] : '') : ''"></HotRecord>

                    </div>
                </el-col>
            </el-row>
            
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import ConcatsControl from '../../templates/concatsControl'
import MapControl from '../../templates/mapControl'
import PriceIndexControl from '../../templates/priceIndexControl'
import HotRecord from '../../templates/hotRecord'
import $ from 'jquery'
import { baseUrl, adIDs, navigationUrl } from '../../assets/js/common'
export default {
    name: 'InforList',
    components: { MapControl, PriceIndexControl, HotRecord, ConcatsControl },
    data () {
        return {
            name: '',
            inforTab_list: [],
            consult_list: [],
            loading: true,
            pagenum: 1,
            totalnum: 0,
            reportClassify: [],
            adIDsIndex: [],
            navigationUrl: navigationUrl
        }
    },
    watch: {    
        '$route' (to, from) {
            //this.$router.go(0);
			window.location.reload()
        }
    },
    mounted () {
        // 初始化内容
        this.name = this.$route.params.name;
        this.getAdByAdp();
        this.tNewsConsultSel();
        this.findNewsClassify();
        this.findReportSortByUserFormat();
    },
    methods: {
        //页面操作
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex = [{
                name: 'indexRight2',
                id: adIDs['indexRight2'],
                list: []
            }];
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },

        findNewsClassify () {
            const self = this;
            $.ajax({
                url: `${baseUrl.service}/api_v3/news_classify?pagenum=1&pernum=99`,
                data: {},
                type: 'get',
                dataType: 'json',
                success: (res) => {
                    if (res.code == 'ok') {
                        self.inforTab_list = [];
                        res.data.forEach((item, index) => {
                            if (item.the_level == 1 && item.is_valid == 'Y') {
                                self.inforTab_list.push(item);
                            }
                        })
                    } else {
                        self.$message.error(res.message);
                    }
                },
                error: () => {
                    self.$message.error('未获取到资讯分类信息')
                }
            })
        },

        tNewsConsultSel () {
            const self = this;
            $.ajax({
                url: `${baseUrl.service}/api_v3/news_classify_dict`,
                data: {
                    type_name: self.name
                },
                dataType: 'json',
                type: 'get', 
                success: (res) => {
                    let classArr = [];    
                    res.data.forEach((item, index) => {
                        if (item.the_level == 2) {
                            classArr.push(item.type_name)
                        }
                    })         
                    self.tNewsConsultFuzzy(classArr)
                },
                error: () => {
                    // self.$message.error('未获取到资讯信息')
                }
            })
        },

        // 获取二级分类
        tNewsConsultFuzzy (arr) {
            const self = this;
            $.ajax({
                url: `${baseUrl.service}/api_v3/t_news_consult_fuzzy`,
                data: {
                    type_name: arr ? arr.join(',') : '',
                    pagenum: self.pagenum,
                    pernum: 10
                },
                dataType: 'json',
                type: 'get', 
                success: (res) => {
                    if (res.data) {
                        self.totalnum = Number(res.data[0].total_num);
                        self.consult_list = res.data;
                    }
                    self.loading = false;
                },
                error: () => {
                    self.loading = false;
                    // self.$message.error('未获取到资讯信息')
                }
            })
        },

        handleCurrentChange (page) {
            const self = this;
            self.loading = true;
            self.pagenum = page;
            self.tNewsConsultSel();
        },

/* ***** 获取报告分类 - 唐宋100指数报告-分品种 下的分类 start ****************************** */

        findReportSortByUserFormat () {
            const self = this;
            self.$get(`${baseUrl.online}/industria/reportSort/findReportSortByUserFormat`, {}).then(res => {
                if(res.code == 0) {
                    res.data.forEach((item, index) => {
                        if (item.childs.length > 0) {
                            self.reportClassify = item.childs;
                        }
                    })
                }else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到报告分类信息');
            })
        },

/* ***** 获取报告分类 - 唐宋100指数报告-分品种 下的分类 end ******************************** */

        /* tab切换 */
        changeInforTab (item, type) {
            if (type) {
                this.$router.push(`/home/inforFastList`)
            } else {
                this.$router.push(`/home/inforList/${item.type_name}`)
            }
        },
        goDetailPage (id) {
            // this.$router.push(`/home/inforDetail/${id}`)
            let routeUrl = this.$router.resolve({
                path: `/home/inforDetail/${id}`
                // query: {id:96}
            });
            window.open(routeUrl.href, '_blank');
        },
        goReportPage (id) {
            this.$router.push(`${navigationUrl['研报']}?sortId=${id}`)
        },
        goSearchPage (name) {
            // this.$router.push(`/home/searchPage?key=${name}&type=1`);
            let routeUrl = this.$router.resolve({
                path: `/home/searchPage?key=${name}&type=1`
            });
            window.open(routeUrl.href, '_blank');
        },

        // 判断时间
        compareTime (date) {
            const time = new Date().getTime();
            const time_1 = new Date(date).getTime();
            const range = time - time_1;
            let time_2;
            let type = 'time';
            if (range <= 1800000) {
                time_2 = Math.floor(range / 60 / 1000);
                // time_2 += '分钟前'
                time_2 = time_2 < 0 ? '刚刚' : time_2 + '分钟前'
            } else if (range < 21600000 && range > 1800000) {
                if (range >= 3600000) {
                    time_2 = Math.floor(range / 60 / 60 / 1000);
                    time_2 += '小时前'
                } else {
                    time_2 = Math.floor(range / 60 / 1000);
                    time_2 += '分钟前'
                }
            } else if (range > 21600000) {
                const newDate = new Date(date);
                time_2 = newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
                type = 'date'
            }
            return time_2
        },

    },
}
</script>

<style scoped>
.part-tab-clist { display: flex; position: relative; border-bottom: 1px solid #eee; padding: 15px 0 10px 0; }
.part-tab-clist:last-child { border: 0; }
.part-tab-clist img { width: 100%; height: 95px; }
.part-tab-clist .tag { 
    position: absolute; top: 20px; left: 5px; background: rgba(0, 0, 0, 0.6); color: #fff; border-radius: 5px; width: 64px; height: 20px; line-height: 20px; 
    text-overflow:ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.part-tab-clist .main { padding-left: 20px; padding-top: 5px; }
.part-tab-clist .main h4 { padding-bottom: 5px; }
.part-tab-clist .main .main-sub { 
    line-height: 20px; 
    height: 40px; 
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    margin-bottom: 5px;
}
.part-tab-clist .main .main-tag {
    border: 1px solid #a30000;
    padding: 0px 5px;
}
</style>